<template>
<history-view :type="1" />
</template>

<script>
import HistoryView from '../../HistoryView'

export default {
  name: 'PMFAnalysisVOCsHistory',
  components: {HistoryView},
  routeInfo: {
    label: '历史数据',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/02VOCs/02History/index.vue